var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pvd-container p-xsmall-top"},[_c('ul',{staticClass:"xsmall no-bullets"},[_c('li',{staticClass:"color-neutral"},[_c('VueShowdown',{attrs:{"extensions":[_vm.formatMarkdown],"markdown":_vm.pd_content.rc_page_disclosure_youth.paragraph2}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }